/**
 * FloatingControls - Container for stacking floating widgets
 *
 * Provides a fixed-position container that stacks children vertically.
 * Children should use position: relative (not fixed).
 *
 * Usage:
 *   <FloatingControls position="top-left">
 *     <MusicWidget />
 *     <LanguageSelector />
 *   </FloatingControls>
 */
import './FloatingControls.css';

const POSITIONS = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];

export default function FloatingControls({
  children,
  position = 'top-left'
}) {
  const positionClass = POSITIONS.includes(position)
    ? `floating-controls--${position}`
    : 'floating-controls--top-left';

  return (
    <div className={`floating-controls ${positionClass}`}>
      {children}
    </div>
  );
}
